export namespace AutoDialer {
    export type Student = {
        userId: number
        profileId: number
        fullName: string
        email: string
        phone: string
    }

    export enum DialerStatus {
        NotStart = "not-start",
        Ringing = "ringing",
        Connected = "connected",
        Hold = "hold",
        Unhold = "unhold",
        Ended = "ended",

        // used for twilio
        Queued = "queued",
        Initiated = "initiated",
        InProgress = "in-progress", // same as connected
        Completed = "completed",
        Canceled = "canceled",
        NoAnswer = "no-answer",
        Busy = "busy",
        Failed = "failed"
    }

    export type DialerStudent = {
        studentProfileId?: number
        status?: DialerStatus
        ringingAt?: string
        connectedAt?: string
        holdAt?: string
        unholdAt?: string
        endedAt?: string
    }

    export type ZoomAuthorization = {
        redirect: boolean
        redirectUri?: string
    }

    export type DialerSocketPayload = {
        profileId: number
        studentProfileId: number
        phone: string
        status: string
        ringingAt?: string
        connectedAt?: string
        holdAt?: string
        unholdAt?: string
        endedAt?: string
        isEnded?: boolean
        errorMessage?: string
    }

    export type CallLog = {
        profileId: number
        enrollmentId: string
        fullName: string
        phone: string
        connectedAt?: string
        endedAt?: string
        duration: number
        recordingUrl?: string
    }
}

export type DialerStudent = {
    userId?: number
    profileId?: number
    fullName?: string
    email?: string
    phone: string
    photo?: string
    dialerId?: number
    campusName?: string
}
